<template>
    <div id="toHelpMeWithContainer" ref="toHelpMeWith">
        <BaseFCPAutoComplete2
            elementId="to-help-me-with-criteria"
            :options="autoCompleteOptions"
            label="to help me with"
            :hideSearchButton="true"
            :initialValue="criteriaContext.term"
            v-model="criteriaContext.term"
            helpText="Specialty, condition or procedure"
        />
        <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
    </div>
</template>
  
<script setup>
    const { criteriaContext, toHelpMeWithItems } = useFCPModel()
    const { loadToHelpMeWithItems } = useApi()

    // const genericType = computed(() => {
    //     if (criteriaContext.value.type.includes('hospital')) {
    //         return 'hospital'
    //     }
    //     return criteriaContext.value.type
    // })

    // const source = computed(() => {
    //     return toHelpMeWithItems.value ? toHelpMeWithItems.value : []
    // })

    const search = (input) => {
      if (input.length < 3) {
        return []
      }

      //if (!source.value) return []
      return toHelpMeWithItems.value?.filter((item) => {
        return item.toLowerCase().includes(input.toLowerCase())
      })
    }

    const autoCompleteOptions = ref({
        search: search,
    })

    onMounted(async () => {
        const result = await loadToHelpMeWithItems(criteriaContext.value)
        
        const medical = result?.value?.medical ?? []
        const dental = result?.value?.dental ?? []   
        
        // care concepts AND procedures
        const titles = [...medical, ...dental]
        // remove duplicates
        toHelpMeWithItems.value = [...new Set(titles)]
    })
  
</script>
  
<style lang="scss">
@use '../../assets/scss/breakpoints' as *;
  
  #toHelpMeWithContainer {
    .autocomplete {
      @include xsmall {
        z-index: 10;
      }
    }
  
    #autocomplete-result-list-1 {
      margin-top: 4px;
      background-color: #fff;
      border: 1px solid var(--color-neutral-xlight);
      box-shadow: 0 3px 6px rgba(149, 157, 165, 0.15);
      list-style: none;
      padding-inline-start: 0px;
      padding-left: 0px;
      position: absolute;
      width: 100%;
      overflow: hidden;
      z-index: 1000;
      margin-right: 4px;
      font-family: var(--text-body-font-sm);
      font-style: var(--text-body-font-sm);
      font-weight: var(--text-body-weight-sm);
      font-size: var(--text-body-pixels-sm);
      line-height: var(--text-body-line-height-sm);
      letter-spacing: var(--text-body-letter-spacing-sm);
      color: var(--color-text-base);
      overflow-wrap: break-word;
  
      li {
        padding-left: 15px;
      }
  
      li:hover {
        background-color: var(--color-neutral-xlight);
      }
  
      li[aria-selected='true'] {
        background-color: var(--color-neutral-xlight);
      }
    }
  }
  </style>